module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de mis vacaciones")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarMensajeDeSolicitud) ? _c('div', {
    key: "mensaje_no_dias",
    staticClass: "mensaje-informacion"
  }, [_c('div', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        _vm.mostrarMensajeDeSolicitud = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]), _c('span', [_vm._v("No puede realizar solicitudes de vacaciones porque cuentas con ")]), _c('strong', [_vm._v(_vm._s(_vm.empleado.diasDisponibles))]), _c('span', [_vm._v(" días disponibles.")]), _c('br'), _c('span', [_vm._v("Debes acumular al menos 1 día para hacerlo.")])])])]) : _vm._e(), (_vm.mostrarSolicitud) ? _c('div', {
    key: "nueva_solicitud",
    staticClass: "box nueva-solicitud"
  }, [_c('nueva-solicitud-vacaciones', {
    on: {
      "close": function($event) {
        _vm.mostrarSolicitud = false
      },
      "successNew": _vm.recargarListaSolicitudes
    }
  })], 1) : _vm._e(), (_vm.mostrarListaSolicitudes) ? _c('div', {
    key: "lista_solicitud",
    staticClass: "box lista-solicitud"
  }, [_c('lista-solicitud-vacaciones', {
    ref: "listasolicitudes",
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudes = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarListaLibrosVacaciones) ? _c('div', {
    key: "lista_libros_vacaciones",
    staticClass: "box lista-solicitud"
  }, [_c('lista-libros-vacaciones', {
    on: {
      "close": function($event) {
        _vm.mostrarListaLibrosVacaciones = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarListaVacaciones) ? _c('div', {
    key: "lista_vacaciones",
    staticClass: "box lista-solicitud"
  }, [_c('lista-vacaciones', {
    on: {
      "close": function($event) {
        _vm.mostrarListaVacaciones = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-599f29d3","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vacaciones_View.vue
// module id = 814
// module chunks = 0